import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import styled from '../../../../../theme/styled';
import mq from '../../../../../commons/styles/mediaQueries';

const ReturnsActionInfoBlock = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  padding: 0 ${({ theme }) => theme.space[16]} ${({ theme }) => theme.space[16]}
    ${({ theme }) => theme.space[16]};
  box-sizing: border-box;

  ${mq.desktop} {
    margin-bottom: ${({ theme }) => theme.space[12]};
    flex-direction: row;
    align-items: center;
    gap: ${({ theme }) => theme.space[10]};
    padding: 0;
    display: flex;
    justify-content: space-between;
  }
`;

const ActionButton = styled(ButtonPrimaryDark)`
  padding: 6px 19px;
  margin-bottom: ${({ theme }) => theme.space[16]};
  font-size: ${({ theme }) => theme.fontSizes[14]};

  ${mq.desktop} {
    margin-bottom: 0;
  }
`;

export default {
  ReturnsActionInfoBlock,
  ActionButton,
};
